import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const accordionItems = [{
  title: '⚖️ Qué vuelve débil un punto pericial',
  items: ['Ambigüedad vs. precisión operativa', 'Delimitación correcta del objeto pericial', 'Uso estratégico del lenguaje técnico', 'Verbos periciales clave', 'Alcance técnico vs. exceso de amplitud']
}, {
  title: '📜 Estructura profesional de punto pericial',
  items: ['Formulación de pedidos ejecutables', 'Control de alcance técnico', 'Plantillas y modelos base']
}, {
  title: '🔍 Delimitación del objeto informático',
  items: ['Tipos de evidencia digital aplicable', 'Límites técnicos del peritaje', 'Modelos reales de aplicación']
}, {
  title: '🔒 Acceso No Autorizado',
  items: ['Intrusión a sistemas sin autorización del titular', 'Eliminación de Información', 'Uso Indebido de Correo', 'Conflicto Laboral con Evidencia Digital', 'Fraude Informático']
}, {
  title: '🏛️ Análisis inicial del caso',
  items: ['Relevamiento y comprensión del objeto pericial', 'Delimitación del alcance y propósito técnico', 'Organización lógica del contenido pericial', 'Verificación de consistencia interna del informe', 'Depuración del lenguaje y ajuste de forma', 'Cierre formal y presentación del dictamen']
}, {
  title: '🎁 BONO 1 — Pack de Plantillas Judiciales Editables',
  items: ['Plantillas listas para usar en distintos fueros', 'Formatos editables adaptables a cada caso', 'Estructura profesional predefinida'],
  isBonus: true
}, {
  title: '🎁 BONO 2 — Guía de Objeciones y Errores Periciales',
  items: ['Errores frecuentes en la formulación pericial', 'Cómo anticipar objeciones de la contraparte', 'Estrategias para blindar tus puntos periciales'],
  isBonus: true
}, {
  title: '🎁 BONO 3 — Biblioteca de Redacción Jurídica Profesional',
  items: ['Fórmulas de redacción probadas', 'Vocabulario técnico-jurídico organizado', 'Modelos de referencia para distintas materias'],
  isBonus: true
}];
function AccordionItem({
  item,
  index
}: {
  item: (typeof accordionItems)[0];
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`rounded-2xl border overflow-hidden transition-all ${item.isBonus ? 'border-gold-500/40 bg-gold-500/5' : 'border-slate-700 bg-slate-800/80'}`} data-id="element-78">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-white/5 transition-colors" data-id="element-79">
        <span className="flex items-center gap-3" data-id="element-80">
          {!item.isBonus && <span className="flex-shrink-0 w-8 h-8 bg-gold-500/20 text-gold-500 rounded-lg flex items-center justify-center text-sm font-bold" data-id="element-81">
              {index + 1}
            </span>}
          <span className={`font-bold text-lg ${item.isBonus ? 'text-gold-400' : 'text-white'}`} data-id="element-82">
            {item.title}
          </span>
        </span>
        <ChevronDown className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-83" />
      </button>
      {isOpen && <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-84">
          <ul className="space-y-3" data-id="element-85">
            {item.items.map((subItem, j) => <li key={j} className="flex items-start gap-3" data-id="element-86">
                <span className={`mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 ${item.isBonus ? 'bg-gold-500' : 'bg-gold-500/60'}`} data-id="element-87"></span>
                <span className="text-slate-300" data-id="element-88">{subItem}</span>
              </li>)}
          </ul>
          {item.isBonus && <div className="mt-4 inline-block text-xs font-bold text-green-400 bg-green-400/10 px-3 py-1.5 rounded-lg" data-id="element-89">
              GRATIS POR HOY
            </div>}
        </div>}
    </div>;
}
export function SalesCopy() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-slate-900/40 border-y border-slate-800/50" data-id="element-90">
      <div className="max-w-3xl mx-auto text-lg text-slate-300 font-sans leading-relaxed" data-id="element-91">
        {/* Intro copy */}
        <div className="text-center mb-16" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-serif text-gold-400 font-bold mb-8" data-id="element-93">
            Tener razón no alcanza si redactás mal
          </h2>
          <p className="text-xl text-slate-200 mb-8" data-id="element-94">
            Muchos abogados tienen en claro que quieren demostrar en un caso,
            pero al momento de redactar:
          </p>
          <div className="inline-flex flex-col items-start gap-3 mb-8 text-left" data-id="element-95">
            <span className="text-white text-lg flex items-center gap-3" data-id="element-96">
              <span className="w-6 text-center" data-id="element-97">❌</span> dudan
            </span>
            <span className="text-white text-lg flex items-center gap-3" data-id="element-98">
              <span className="w-6 text-center" data-id="element-99">❌</span> reescriben
            </span>
            <span className="text-white text-lg flex items-center gap-3" data-id="element-100">
              <span className="w-6 text-center" data-id="element-101">❌</span> buscan modelos viejos
            </span>
            <span className="text-white text-lg flex items-center gap-3" data-id="element-102">
              <span className="w-6 text-center" data-id="element-103">❌</span> pierden tiempo
              innecesario
            </span>
          </div>
          <p className="text-xl text-slate-200 mb-4" data-id="element-104">Y lo peor:</p>
          <p className="text-xl text-gold-400 font-serif font-bold" data-id="element-105">
            ⚖️ una mala formulación puede debilitar la fuerza del caso antes de
            la pericia.
          </p>
        </div>

        {/* "Es para vos si..." - moved above accordions */}
        <div className="bg-slate-800/90 p-8 md:p-12 rounded-3xl border border-slate-700 my-16 shadow-2xl" data-id="element-106">
          <h3 className="text-3xl font-serif text-white mb-10 text-center font-bold" data-id="element-107">
            Este recurso es para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-108">
            <li className="flex items-start" data-id="element-109">
              <span className="text-gold-500 mr-4 mt-1 text-xl" data-id="element-110">✓</span>
              <span className="text-lg" data-id="element-111">
                Redactar puntos periciales te consume más tiempo del que
                debería.
              </span>
            </li>
            <li className="flex items-start" data-id="element-112">
              <span className="text-gold-500 mr-4 mt-1 text-xl" data-id="element-113">✓</span>
              <span className="text-lg" data-id="element-114">
                Sentís que tus escritos podrían tener más fuerza.
              </span>
            </li>
            <li className="flex items-start" data-id="element-115">
              <span className="text-gold-500 mr-4 mt-1 text-xl" data-id="element-116">✓</span>
              <span className="text-lg" data-id="element-117">
                Muchas veces sabés lo que querés pedir, pero te cuesta
                formularlo correctamente.
              </span>
            </li>
            <li className="flex items-start" data-id="element-118">
              <span className="text-gold-500 mr-4 mt-1 text-xl" data-id="element-119">✓</span>
              <span className="text-lg" data-id="element-120">
                Terminás usando modelos viejos que no encajan del todo.
              </span>
            </li>
            <li className="flex items-start" data-id="element-121">
              <span className="text-gold-500 mr-4 mt-1 text-xl" data-id="element-122">✓</span>
              <span className="text-lg" data-id="element-123">
                Querés dejar de depender de la improvisación.
              </span>
            </li>
          </ul>
        </div>

        {/* Accordions */}
        <div className="my-16" data-id="element-124">
          <h3 className="text-3xl font-serif text-white mb-10 text-center font-bold" data-id="element-125">
            ¿Qué incluye el sistema?
          </h3>
          <div className="space-y-4" data-id="element-126">
            {accordionItems.map((item, i) => <AccordionItem key={i} item={item} index={i} data-id="element-127" />)}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center my-16" data-id="element-128">
          <a href="https://checkout.ebookpoint.shop/cart/59452963192913:1" className="inline-block w-full md:w-auto bg-[#dc2626] hover:bg-[#ef4444] text-white font-black text-xl px-12 py-5 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:-translate-y-1 uppercase tracking-wide border-b-4 border-[#991b1b]" data-id="element-129">
            ¡QUIERO EL SISTEMA AHORA!
          </a>
        </div>
      </div>
    </section>;
}